import { Link } from "react-router-dom";
const Branding = () => {
    return (
      <Link to="/">
        <img src="logo.svg" alt="Remaster logo" />
      </Link>
    );
}

export default Branding;